import { Action } from '@ngrx/store';
import { StoreAction } from '../../decorators/store-action/store-action.decorator';
import { GenericStoreAction } from '../generic/generic-action';

@StoreAction("Banks")
export class BanksAction extends GenericStoreAction {

    constructor(public type: string, public payload?: any) {
        super(type, payload);
    }
}
